module.exports = __webpack_public_path__ + "static/img/worth3.5e7dc75c.png";